import sidebar from './parts/league/run/sidebar';

(() => {
  sidebar();
})()
